import styled from 'styled-components';
import { Layout } from 'antd';

export const Container = styled(Layout)`
  min-height: 100%;

  > .ant-layout-content {
    padding: 30px;
  }
`;
